import angular from 'angular'

import commandeAsk from './services/ask.service'
import commandeData from './services/data.service'
import commandeFormat from './services/format.service'
import commandeGo from './services/go.service'
import commandeLocal from './services/local.service'
import commandeMetadata from './services/metadata.service'
import commandeRequest from './services/request.service'
import commandeResource from './services/resource.service'
import commande from './services/commande.service'

import myCommandeCreateForm from './directives/forms/myCommandeCreateForm'
import myCommandeEditForm from './directives/forms/myCommandeEditForm'
import myCommandeForm from './directives/forms/myCommandeForm'
import myCommande from './directives/display/myCommande'
import myCommandeDisplay from './directives/display/myCommandeDisplay'
// import mySelectRailway from './directives/inputs/mySelectRailway'
// import myCommandeSelectCard from './directives/inputs/myCommandeSelectCard'

import commandeButtons from './resources/buttons.resource'
import commandeIcons from './resources/icons.resource'
import commandeFields from './resources/fields.resource'
import commandeLabels from './resources/labels.resource'

const name = 'commande'
angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('commandeAsk', commandeAsk)
  .factory('commandeData', commandeData)
  .factory('commandeFormat', commandeFormat)
  .factory('commandeGo', commandeGo)
  .factory('commandeLocal', commandeLocal)
  .factory('commandeMetadata', commandeMetadata)
  .factory('commandeRequest', commandeRequest)
  .factory('commandeResource', commandeResource)
  .factory('$$commande', commande)
  // ===== DIRECTIVES ===== //
  .directive('myCommandeCreateForm', myCommandeCreateForm)
  .directive('myCommandeEditForm', myCommandeEditForm)
  .directive('myCommandeForm', myCommandeForm)
  .directive('myCommande', myCommande)
  .directive('myCommandeDisplay', myCommandeDisplay)
  // .directive('mySelectRailway', mySelectRailway)
  // .directive('myCommandeSelectCard', myCommandeSelectCard)
  // ===== RESOURCES ===== //
  .factory('commandeButtons', commandeButtons)
  .factory('commandeIcons', commandeIcons)
  .factory('commandeFields', commandeFields)
  .factory('commandeLabels', commandeLabels)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/commande.module.js